import { create } from 'zustand'

import { strToBool } from '../../utils/util';

import { isEmpty } from 'lodash';

const convertFilters = (filters) => {
  let queryString = "";
  // iterate through query object
  for (let key in filters) {
    // if query value is not an object (primitive), append to queryString
    if (typeof filters[key] !== "object") {
      queryString += `&${key}=${encodeURIComponent(filters[key])}`;
    } else if (filters[key] instanceof Date) {
      queryString += `&${key}=${filters[key].toISOString()}`; // Convert date to ISO string
    }else if (Array.isArray(filters[key])) { // if query value is an array, join values and append to queryString
      queryString += `&${key}=${filters[key].map(cur => encodeURIComponent(cur)).join(",")}`;
    } else { // if query value is an object, iterate through object and append to queryString
      for (let subKey in filters[key]) {
        let value = Array.isArray(filters[key][subKey]) ? filters[key][subKey].map(cur => encodeURIComponent(cur)).join(",") : filters[key][subKey]; // if value is an array, join values
        queryString += `&${key}[${subKey}]=${value}`;
      }
    }
  }
  return queryString;
}


const getValue = (e, type) => {
  let value;
  if (type === "check") {
    value = e.target.checked;
  } else if (type === "boolean") {
    value = strToBool(e.target.value);
  } else if (type === "date" || type === "range" || type === "array") {
    value = e;
  } else {
    value = e.target.value;
  }
  return value;
}


const handleTableFilter = (e, tableName, fieldName, queryType, fieldType, set) => {
  set((prevQuery) => {
    const newQuery = { ...prevQuery.tableFilters };

    // Create a new object for tableName if it doesn’t exist, or copy the existing one
    newQuery[tableName] = newQuery[tableName]
      ? { ...newQuery[tableName] }
      : {};

    if (!queryType) {
      // If no queryType is provided, set the entire field to the value directly
      newQuery[tableName][fieldName] = e;
    } else {
      const value = getValue(e, fieldType);
       // Create a new object for fieldName if it doesn’t exist, or copy the existing one
      newQuery[tableName][fieldName] = newQuery[tableName][fieldName]
      ? { ...newQuery[tableName][fieldName] }
      : {};
      newQuery[tableName][fieldName][queryType] = value;
    }

    return { tableFilters: newQuery };
  });
};

const resetTableFilters = (tableName, fieldName, queryType, refresh = false, set) => {
  
  set((prevQuery) => {
    if (isEmpty(prevQuery.tableFilters)){
      console.log("prevQuery.tableFilters is empty");
       return { tableFilters: {}, tableFilterString: {} }
    };
    const newQuery = { ...prevQuery.tableFilters };
    let filterString = { ...prevQuery.tableFilterString };
    // If tableName is not provided, reset all table filters
    if (!tableName) {
      return { tableFilters: {}, tableFilterString: {} };
    }
    if (!newQuery[tableName]) {
      return;
    }
    // If fieldName is not provided, reset all filters for the table
    if (!fieldName) {
      delete newQuery[tableName];
      delete filterString[tableName];
      return { tableFilters: newQuery, tableFilterString: filterString };
    }
    if (!newQuery[tableName][fieldName]) {
      return;
    }
    // If queryType is provided, remove the specific query type, else remove the entire field
    if (queryType) {
      newQuery[tableName] = {
        ...newQuery[tableName],
        [fieldName]: { ...newQuery[tableName][fieldName] },
      };
      delete newQuery[tableName][fieldName][queryType];
    } else {
      newQuery[tableName] = { ...newQuery[tableName] };
      delete newQuery[tableName][fieldName];
    }
    // If refresh is true, convert filters to filterString
    if (refresh) {
      filterString = { ...filterString, [tableName]: convertFilters(newQuery[tableName]) };
    }
    return { tableFilters: newQuery, tableFilterString: filterString };
  });
}

const getSortedColumns = (tableId, headers, get) => {
  const storedTableColumns = get(state => state.tableColumnSort[tableId]) || [];
  let newColumns = headers;
  if (storedTableColumns.length) {
    newColumns = storedTableColumns.map(cur => cur.active && headers.find(header => header.id === cur)).filter(cur => cur);
  }
  return newColumns;
}

const setSortedColumns = (tableId, columns, set) => {
  set((prevColumns) => {
    const newColumns = {...prevColumns.tableColumnSort}
    newColumns[tableId] = columns;
    return { tableColumnSort: newColumns };
  })
}

const setSearchTermDebounced = (tableId, searchTerm, set) => {
  set((prevColumns) => {
    const newColumns = {...prevColumns.tableSearchTermDebounced}
    newColumns[tableId] = searchTerm;
    return { tableSearchTermDebounced: newColumns };
  })
}
const setSearchTerm = (tableId, searchTerm, set) => {
  set((prevColumns) => {
    const newColumns = {...prevColumns.tableSearchTerm}
    newColumns[tableId] = searchTerm;
    return { tableSearchTerm: newColumns };
  })
}

const useTableStore = create((set, get) => ({
  tableFilters: {}, // for storing filters for multiple tables
  tableFilterString: {}, // for storing filter strings for multiple tables
  tableFinalQueryString: {},
  tableSearchTermDebounced: {}, // for storing search terms for multiple tables
  setTableSearchTermDebounced: (tableId, searchTerm) => setSearchTermDebounced(tableId, searchTerm, set),
  tableSearchTerm: {}, // for storing search terms for multiple tables
  setTableSearchTerm: (tableId, searchTerm) => setSearchTerm(tableId, searchTerm, set),
  handleTableFilter: (e, tableName, fieldName, queryType = null, fieldType = null) => handleTableFilter(e, tableName, fieldName, queryType, fieldType, set),
  resetTableFilters: (tableName, fieldName = null, queryType = null, refresh = false) => resetTableFilters(tableName, fieldName, queryType, refresh, set),
  convertTableFilters: (tableId) => set((state) => ({
    tableFilterString: { ...state.tableFilterString, [tableId]: convertFilters(state.tableFilters[tableId]) }
  })),
  setTableFinalQueryString: (tableId, queryString) => set((state) => ({
    tableFinalQueryString: { ...state.tableFinalQueryString, [tableId]: queryString }
  })),

  tableColumnSort: {},
  getSortedColumns: (tableId, headers) => getSortedColumns(tableId, headers, get),
  setSortedColumns: (tableId, columns) => setSortedColumns(tableId, columns, set)
}))

export default useTableStore;


